<template>
  <input-text
    id="input:nomProdutoServico"
    v-model="payload.nomProdutoServico"
    :rules="[requiredRule]"
    label="Nome do produto"
    :loading="loading"
    required
  />
</template>

<script>
import RulesMixin from '@/app/arch/mixins/RulesMixin';

export default {
  name: 'NomeProduto',
  mixins: [RulesMixin],
  props: {
    payload: {
      type: Object,
      default() {
        return {
          nomProdutoServico: '',
        };
      },
    },
    loading: {
      type: Boolean,
    },
  },
};
</script>
